import { Col, DatePicker, Form, Input, message, Modal, Row } from "antd";
import { Rule } from "antd/lib/form";
import { shopApi } from "api/shop.api";
import { staffApi } from "api/staff.api";
import { SingleImageUpload } from "components/Upload/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Shop } from "types/shop";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true }];

export const SuspendModal = ({
  visible,
  status,
  onClose,
  onSubmitOk,
  shopIds,
}: {
  visible: boolean;
  status: ModalStatus;
  onClose: () => void;
  shopIds: number[];
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<{ note?: string }>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, [visible, status]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const note = form.getFieldValue("note");
      for (let i = 0; i < shopIds.length; i++) {
        const e = shopIds[i];

        const dataPost = {
          suspend: {
            note,
            // expiredAt: dayjs(expiredSuspendAt).endOf("day").unix(),
          },
        };
        await shopApi.suspend(e || 0, dataPost);
      }
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible]);

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={"Đình chỉ"}
      style={{ top: 20 }}
      width={400}
      confirmLoading={loading}
      onOk={() => {
        handleSubmit();
      }}
    >
      <Form layout="vertical" form={form}>
        {/* <Form.Item
          label="Chọn thời gian hết đình chỉ"
          name="expiredSuspendAt"
          rules={rules}
        >
          <DatePicker placeholder="Chọn thời gian" style={{ width: "100%" }} />
        </Form.Item> */}

        <Form.Item label="Ghi chú" name="note">
          <Input placeholder="Ghi chú" />
        </Form.Item>
      </Form>
    </Modal>)
  );
};
